<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      获得信贷对标排名
    </div>
    <div class="paiming2">
      <div class="head">
        <div class="item1">排名</div>
        <div class="item2">城市</div>
        <div class="item3">{{ title }}</div>
      </div>
      <div class="body">
        <div class="bodyitem" v-for="(item,index) in list" :key="index">
          <div class="item1">{{ index + 1 }}</div>
          <div class="item2">{{ item.title }}</div>
          <div class="item3">{{ item.fenshu }}分</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paiming",
  data: function () {
    return {}
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    },
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 100%;
  height: 610px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;

  .head {
    margin-left: 24px;
    margin-right: 24px;
    height: 94px;
    background: #69C0D2;
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  margin: auto;
  margin-left: 24px;
  margin-right: 24px;
}

.bodyitem {
  height: 100px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;
  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}
</style>
